<h1 [class]="cssClass">
  {{ displayTitle }}
</h1>
